(function () {
  function moveReviews() {
    var leftColumn = document.querySelector('[data-product-left-column]');
    var reviewsSection =
      document.getElementById('shopify-section-google_reviews_lessons') ||
      document.querySelector('[id^="shopify-section-"][id*="google_reviews_lessons"]');
    if (leftColumn && reviewsSection && !leftColumn.contains(reviewsSection)) {
      leftColumn.appendChild(reviewsSection);
      return true;
    }
    return false;
  }
  function run() {
    if (moveReviews()) return;
    setTimeout(moveReviews, 150);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(run);
    });
  } else {
    requestAnimationFrame(run);
  }
})();
